/**
 * 查找正文中的视频并且添加播放事件
 */
"use strict";
angular.module("queryVideoAndAudioModule", []).
directive("queryVideoAndAudio", ["$timeout", "playVideoService", function($timeout, playVideoService) {
	return {
		restrict: "A",
		scope: false,
		template: "<div></div>",
		link: function(scope, element, attrs) {
			element[0].onclick = function(e) {
				if(e.target.tagName && e.target.tagName === 'IMG') {
					var img = e.target;
					if(scope.status.isBackstage) {
						if(img.getAttribute("videoId")) {
							playVideoService.openPlayVideoPage(img.getAttribute("videoId"), 'video',true);
						}
						if(img.getAttribute("audioId")) {
							playVideoService.openPlayVideoPage(img.getAttribute("audioId"), 'audio',true);
						}
					} else {

						if(img.getAttribute("videoId")) {
							playVideoService.openPlayVideoPage(img.getAttribute("videoId"), 'video',false);
						}
						if(img.getAttribute("audioId")) {
							playVideoService.openPlayVideoPage(img.getAttribute("audioId"), 'audio',false);
						}
					}
				}
			}
		}
	};
}]);